import axios from 'axios'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

/**
 * 封装导出Excel文件请求
 * @param url
 * @param data
 * @returns {Promise}
 */
// api.js
export function exportExcel(url, options = {}) {
  return new Promise((resolve, reject) => {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_API
    axios.defaults.headers['Authorization'] = getToken()
    axios({
      method: 'post',
      url: url, // 请求地址
      data: options, // 参数
      timeout: 120000,
      responseType: 'blob' // 表明返回服务器返回的数据类型
    }).then(response => {
      resolve(response.data)

      if (response.data.type === 'application/json') {
        const reader = new FileReader() // 创建一个FileReader实例
        reader.readAsText(response.data, 'utf-8') // 读取文件,结果用字符串形式表示
        reader.onload = function () { // 读取完成后,**获取reader.result**
          const result = JSON.parse(reader.result)
          Message.error(result.message)
        }
        return
      }

      let fileName = response.headers['content-disposition'].split('=')[1]
      fileName = decodeURI(fileName)
      const blob = new Blob([response.data])
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName)
      } else {
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName.replace(new RegExp('"', 'g'), '')
        link.click()
        // 释放内存
        window.URL.revokeObjectURL(link.href)
      }
    },
    err => {
      reject(err)
    }
    )
  })
}
